import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';
import { globalSearchSkillResponseSchema } from '../../../data-contract/global-search';

import type { GeneralFilter } from '../../../../../shared/source/data-contract/filter';
import type { GlobalSearchSkillResponse } from '../../../data-contract/global-search';
import type { UseQueryResult } from '@tanstack/react-query';

export type GlobalSearchDirectorySkillsSortOption = {
    readonly direction: 'asc' | 'desc';
    readonly field: string;
};

export const useGlobalSearchDirectorySkills = ({
    filterPayload,
    page,
    pageSize,
    sortOptions,
}: {
    readonly filterPayload?: GeneralFilter;
    readonly page: number;
    readonly pageSize: number;
    readonly sortOptions: readonly GlobalSearchDirectorySkillsSortOption[];
}): UseQueryResult<GlobalSearchSkillResponse, Error> => {
    const { applicationState, validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname = '/global/directory/skills/filter';

    return useQuery({
        placeholderData: keepPreviousData,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.postJson(globalSearchSkillResponseSchema, {
                pathname,
                payload: {
                    filter: filterPayload,
                    paged: {
                        page: String(page),
                        size: String(pageSize),
                    },
                    sorted: {
                        fields: sortOptions,
                    },
                },
            });

            if (result.isOk) {
                return result.value;
            }
            throw result.error;
        },
        queryKey: [pathname, 'postJson', applicationState.language.code, filterPayload, page, pageSize, sortOptions],
    });
};
